import CreateApi from "../../../shared/Settings/appSettings";


export async function FetchStaticDataOptions(api: any) {

    let optionsLoaded: any[] = [];

    await api.get('/tb/GetReferenceData')
    .then((res: any) => {
        console.log('Ref Data', res.data);
        res.data.map((o: any) => {
            optionsLoaded = [...optionsLoaded, {keyName: o.refName, options: o.options.sort((a: any, b: any) => {
                if (a.group && b.group) return a.group.localeCompare(b.group);
                if (a.type && b.type) return a.type.localeCompare(b.type);
                return 0;
            })}];
        });

    });

    await api.get('/tb/GetCourseOptions')
    .then((res: any) => {
        console.log('Course Options', res.data);
        optionsLoaded = [...optionsLoaded, {keyName: 'courses', options: res.data}];
    });

    console.log('Options Loaded', optionsLoaded);
    console.log('Find Data', optionsLoaded.find((o: any) => o.keyName === 'PlayTypes')?.options);

    return optionsLoaded

};